import DialogWithCloseButton from 'components/DialogWithCloseButton'
import DragAndDropUploader from 'components/ReusableComponents/DragAndDropUploader'
import { useRef } from 'react'

import styles from './FileUploadDialog.module.scss'

const FileUploadDialog = ({
  handleClose,
  handleUploadedFiles,
  maxFileSize,
  acceptedFileTypes
}) => {
  const ref = useRef()

  return (
    <DialogWithCloseButton title="Upload an a file" handleClose={handleClose}>
      <div className={styles.dropZone}>
        <DragAndDropUploader
          url="/media"
          onData={formData => formData}
          onLoad={res => {
            const data = JSON.parse(res)
            handleUploadedFiles(data.result)
          }}
          maxFileSize={maxFileSize}
          acceptedFileTypes={acceptedFileTypes}
          ref={ref}
          onError={res => console.warn('file response', res)}
          labelIdle="
              <i class='filepond-upload-icon'></i>
              <p class='filepond-p'>drop a file here</p>
              <span class='filepond-or'>or</span> <span class='filepond--label-action'>Select from your computer</span>"
          labelFileProcessingError={err => `${err.code} - Something went wrong`}
        />
      </div>
    </DialogWithCloseButton>
  )
}

export default FileUploadDialog
